import { useQuery } from '@apollo/react-hooks';
import { getMstiTypeFromUrl, getUrlSearchParams } from '@src/core/utils';
import { getMstiTypeColor, getMstiTypeValue, styled } from '@src/globalStyles';

import React, { useState } from 'react';
import { RouteComponentProps, useHistory, useLocation } from 'react-router-dom';

import { MstiType, MstiTypeComponent } from './MstiType';

import { mstiTypes } from './__generated__/mstiTypes';
import { MSTI_TYPE } from './queries';
import { Loading } from '@src/components/atoms/Loading';
import SEO from 'react-seo-component';

import { APP_STORE_URL, PLAY_STORE_URL } from '@src/utils/constants';

const MstiWrapper = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FlexWrapper = styled.div`
  background-color: #fafafa;
  width: 400px;
  height: 860px;
  overflow-y: scroll;
  box-shadow: -1px 3px 21px -10px #222;
`;

const MstiTitle = styled.div`
  background-color: white;
  text-align: center;
  font-size: 18px;
  box-shadow: 0 4px 6px -6px #222;
  padding: 10px 0 10px 0;
  margin-bottom: 4px;
`;

const MstiMention = styled.div`
  text-align: center;
  font-size: 23px;
  background-color: white;
  padding: 29px 0 10px 0;
`;

const MstiQuestionTitle = styled.div`
  font-size: 15px;
  font-weight: bold;
  margin-top: 8px;
  background-color: white;
  padding: 13px 0 0 17px;
`;
const MstiQuestionMidTitle = styled.div`
  background-color: white;
  padding: 8px 0 13px 17px;
  font-size: 13px;
`;

const MstiActionChipWrapper = styled.div`
  height: 42px;
  margin: 1px 0 1px 0;
  background-color: white;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
`;

const MstiActionChip = styled.button`
  height: 29px;
  border-radius: 17px;
  background-color: yellow;
  padding: 5px 10px;
  margin-left: 13px;
  flex: 0 0 auto;
`;

const MstiDescriptionWrapper = styled.div`
  background-color: white;
  display: flex;
  overflow-y: auto;
  flex-wrap: wrap;
  border-radius: 13px;
`;

const MstiDescriptionLetterWrapper = styled.div`
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  background-color: #fff8dd;
  padding: 20px 30px 0 30px;
  margin: 0 13px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MstiDescriptionLetter = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 50%;
  font-size: 54px;
  font-weight: 800;
  text-align: center;
  line-height: 88px;
  background-color: cornflowerblue;
`;

const MstiDescriptionTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  background-color: #fff8dd;
  padding: 20px 30px;
  margin: 0 13px;
`;

const OnMstiDescription = styled.div`
  border-radius: 13px;
  background-color: #fff8dd;
  padding: 20px 30px;
  margin: 0px 13px 20px 13px;
  &:nth-child(1) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;

const GoToMaccaronAppWrapper = styled.div`
  position: fixed;
  bottom: 0;
  background-color: #fff;
  right: 0;
  width: 100%;
  z-index: 99;
  border-top: 1px solid #ddd;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GoToMaccaronAppButton = styled.button`
  background-color: #d1599e;
  color: white;
  padding: 13px 50px;
  border-radius: 17px;
`;

export type IProps = RouteComponentProps<{ mstiType: string }>;

const MstiResultPage: React.FC<IProps> = ({ match }) => {
  const history = useHistory();
  const rLocation = useLocation();

  const queryParams = new URLSearchParams(rLocation.search);
  const mstiType = queryParams.get('type');
  const acneType = getUrlSearchParams(window.location.href, 'acne');

  const [onDescriptions, setOnDescriptions] = useState({});
  const [onDescription, setOnDescription] = useState([]);

  const { data: mstiTypeData } = useQuery<mstiTypes>(MSTI_TYPE, {
    variables: { typeString: mstiType },
    onCompleted: (data) => {
      setOnDescriptions(data.mstiTypes.edges);
      setOnDescription(mstiTypeData.mstiTypes.edges[comp].node.descriptions.edges.map((e) => e.node.description));
    },
  });

  const handleRedirectApp = () => {
    exeDeepLink();
    checkInstallApp();
  };

  const handleRedirectAppDeleted = () => {
    checkInstallApp();
    const url = `maccaron://maccaron.in/en/msti/result`;
    location.href = url;
  };

  function checkInstallApp() {
    function clearTimers() {
      clearInterval(check);
      clearTimeout(timer);
    }

    function isHideWeb() {
      if (document.hidden) {
        clearTimers();
      }
    }

    const check = setInterval(isHideWeb, 200);

    const timer = setTimeout(function () {
      redirectStore();
    }, 500);
  }

  const redirectStore = () => {
    const ua = navigator.userAgent.toLowerCase();
    location.href = ua.indexOf('android') > -1 ? PLAY_STORE_URL : APP_STORE_URL;
  };

  function exeDeepLink() {
    const url = `maccaron://maccaron.in/en/msti/result/${match.params.mstiType}`;
    location.href = url;
  }

  const [comp, setComp] = useState(0);

  const runCallback = (cb) => {
    return cb();
  };

  return (
    (mstiTypeData &&
      ((mstiType.slice(-1) == 'A' && acneType.length > 0) || (mstiType.slice(-1) == 'F' && acneType.length == 0) ? (
        <>
          <MstiWrapper>
            <SEO
              title="Are you curious about what product fits your skin concerns?"
              description="Ask question, get an answer"
              titleTemplate={''}
              titleSeparator={`-`}
              image="https://d1iuscsovtvj4y.cloudfront.net/community_share.jpg"
              pathname={location.href || ''}
              siteLanguage="en"
              siteLocale="en_GB"
              twitterUsername=""
            />
            <FlexWrapper>
              <MstiTitle>MSTI - Dignosis</MstiTitle>
              <MstiMention>My MSTI is</MstiMention>
              <MstiType
                skinType={mstiType}
                componentType={MstiTypeComponent.FullResult}
                acneTypeList={acneType}
              ></MstiType>
              <MstiQuestionTitle>What's my skin type?</MstiQuestionTitle>
              <MstiQuestionMidTitle>MSTI Dignosis</MstiQuestionMidTitle>
              <MstiActionChipWrapper>
                {mstiTypeData.mstiTypes.edges.map((mstiLetter, i) => {
                  return (
                    <>
                      <MstiActionChip
                        key={i}
                        onClick={() => {
                          setComp(i);
                        }}
                        style={{
                          backgroundColor: getMstiTypeColor(mstiLetter.node.letter.toLocaleLowerCase())['background'],
                        }}
                      >
                        {getMstiTypeValue(mstiLetter?.node?.letter?.toLowerCase() ?? '')}
                      </MstiActionChip>
                    </>
                  );
                })}
              </MstiActionChipWrapper>
              <MstiDescriptionLetterWrapper>
                <MstiDescriptionLetter
                  style={{
                    backgroundColor: getMstiTypeColor(
                      mstiTypeData.mstiTypes.edges[comp].node.letter.toLocaleLowerCase(),
                    )['background'],
                  }}
                >
                  {mstiTypeData.mstiTypes.edges[comp].node.letter}
                </MstiDescriptionLetter>
              </MstiDescriptionLetterWrapper>
              <MstiDescriptionTitle>
                {getMstiTypeValue(mstiTypeData.mstiTypes.edges[comp].node.letter.toLocaleLowerCase()) + ' skin type'}
              </MstiDescriptionTitle>
              <MstiDescriptionWrapper>
                {runCallback(() => {
                  const column = [];
                  for (var i = 0; i < 4; i++) {
                    column.push(
                      <OnMstiDescription
                        dangerouslySetInnerHTML={{
                          __html: mstiTypeData.mstiTypes.edges[comp].node.descriptions.edges.map(
                            (e) => e.node.description,
                          )[i],
                        }}
                      />,
                      // </div>
                    );
                  }
                  return column;
                })}
              </MstiDescriptionWrapper>
            </FlexWrapper>
          </MstiWrapper>
          {/* go to maccaron app */}
          <GoToMaccaronAppWrapper>
            <GoToMaccaronAppButton onClick={handleRedirectApp}>Find out My Skintype</GoToMaccaronAppButton>
          </GoToMaccaronAppWrapper>
        </>
      ) : (
        history.goBack()
      ))) || <Loading />
  );
};

export default MstiResultPage;
